import qs from 'query-string';
import { emitter, CONTACT_FORM_SUBMITTED } from '@phoenix/event-bus';

export default {
  props: {
    subjects: {
      type: Array,
      default: () => [],
    },
    countries: {
      type: Array,
      required: true,
    },
    redirectUrl: {
      type: String,
      required: false,
      default: '',
    },
    blockId: {
      type: Number,
      required: true,
    },
    enableCaptcha: {
      type: Boolean,
      default: true,
    },
    subjectFields: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      values: {},
    };
  },

  computed: {
    action() {
      return window.route('api.form.contact.save');
    },
  },

  created() {
    this.setFields({
      blockId: {
        id: 'blockId',
        name: 'blockId',
        value: null,
        type: 'hidden',
      },
      country: {
        id: 'country',
        name: 'country',
        label: this.$t('Form.label.country'),
        value: null,
        options: [],
        required: true,
        type: 'select',
      },
      subject: {
        id: 'subject',
        name: 'subject',
        label: this.$t('Form.topic'),
        value: null,
        options: [],
        required: true,
        type: 'select',
      },
      message: {
        id: 'message',
        name: 'message',
        label: this.$t('Form.message'),
        value: '',
        required: true,
        type: 'textarea',
      },
      newsletter: {
        id: 'newsletter',
        name: 'newsletter',
        label: this.$t('Form.stayInTouch', {
          privacyLink: `<a target='_blank' class='rcms_privacypol link link--text' href='${this.terms}'>${this.$t(
            'Form.privacy',
          )}</a>`,
        }),
        type: 'checkbox',
        value: false,
      },
    });
  },

  mounted() {
    this.fields.blockId.value = this.blockId;
    this.fields.subject.options = this.subjects;

    if (this.subjects.length === 1) {
      this.fields.subject.value = this.subjects[0].value;
      this.fields.subject.type = 'hidden';
    }

    this.setDefaultSubject();
  },

  methods: {
    async addTrackingInformation() {
      const contactMode = this.fields?.preferredContactMode?.value || 'email';
      const email = this.fields?.email?.value;
      const event = await window.tracking.getContactFormTracking(contactMode, this.fields.subject.value, email);
      window.tracking.pushEvent(event);
      emitter.emit(CONTACT_FORM_SUBMITTED, { contactMode, contactReason: this.fields.subject.value });
    },

    shouldDisplayField(field) {
      const fields = this.subjectFields[this.fields.subject.value] || {};

      return Object.values(fields).includes(field);
    },

    setDefaultSubject() {
      const queryString = qs.parse(window.location.search);
      if (queryString.reference) {
        this.fields.subject.value = 'product_information';
      }
    },

    setPhoneIsRequired() {
      if (this.fields.phone) {
        this.fields.phone.required = this.fields.preferredContactMode.value !== 'email';
      }
    },
  },
};
